import Vue from "vue";
import VueRouter from "vue-router";
import { RouteName } from "./types";
import { routes } from "./routes";
import storageService from "../services/storageService/storageService";
import { LocalStorageItems } from "@/helpers/constants";
import apiService from "@/services/apiService/apiService";
import store from "@/store";
import { Namespace } from "@/store/types";
import { AlertAction, AlertType } from "@/components/alert/types";
import apiStorageInterface from "@/services/apiStorageInterface";
import { i18n } from "@/plugins/i18n/vue-i18n-plugin";
import { Locale } from "@/plugins/i18n/types";

Vue.use(VueRouter);

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  if (to.meta?.requiresAuth) {
    try {
      const cachedToken = storageService.getItem<string>(
        LocalStorageItems.Token
      );
      const cachedDeviceId = storageService.getItem<string>(
        LocalStorageItems.DeviceId
      );
      const isTokenValid =
        cachedToken && cachedDeviceId
          ? await apiService.isLoggedIn({
              token: cachedToken,
              deviceId: cachedDeviceId
            })
          : false;
      if (isTokenValid !== undefined) {
        if (storageService.hasItem(LocalStorageItems.UserInfo)) {
          const userInfo = await apiStorageInterface.fetchUserInfo();
          i18n.locale = userInfo.defaultUserLanguage
            ? userInfo.defaultUserLanguage.code
            : Locale.EN;
        }
        return next();
      } else {
        await store.dispatch(`${Namespace.Alert}/${AlertAction.UpdateAlert}`, {
          show: true,
          message: "Your Session has expired.",
          alertType: AlertType.Info
        });
        return next({ name: RouteName.Login });
      }
    } catch (error) {
      await store.dispatch(`${Namespace.Alert}/${AlertAction.UpdateAlert}`, {
        show: true,
        message: "Your Session has expired.",
        alertType: AlertType.Info
      });
      return next({ name: RouteName.Login });
    }
  }

  return next();
});

export default router;
